import { Button } from "@components/ui/button"
import {
  AccountOfferFunnelProvider,
  useAccountOfferFunnel,
} from "./utils/useAccountOfferFunnel"
import { ChooseOffer } from "./FunnelSteps/ChooseOffer"
import { Verification } from "./FunnelSteps/Verification"
import { Confirmation } from "./FunnelSteps/Confirmation"
import { OfferDetail } from "./FunnelSteps/OfferDetail"
import { CancelMember } from "./FunnelSteps/CancelMember"

const OffersInner = () => {
  const { offerType, step, setStep } = useAccountOfferFunnel()

  return (
    <>
      {offerType && (
        <div className="tw:bordered-container">
          {step === "initial" && (
            <Button variant="default" onClick={() => setStep("chooseOffer")}>
              View {offerType} Offers
            </Button>
          )}

          {step === "chooseOffer" && <ChooseOffer />}

          {step === "offerDetail" && <OfferDetail />}

          {step === "verification" && <Verification />}

          {step === "cancelMember" && <CancelMember />}

          {step === "confirmation" && <Confirmation />}
        </div>
      )}
    </>
  )
}

export const OffersFunnel = ({ account_id }: { account_id: string }) => (
  <AccountOfferFunnelProvider account_id={account_id}>
    <OffersInner />
  </AccountOfferFunnelProvider>
)
